const initialState = {
  versadriveSetting: {},
};

function versadriveSetting(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_VERSADRIVE_SETTING':
      return {
        ...state,
        versadriveSetting: action.versadriveSetting,
      };
    default:
      return state;
  }
}

export default versadriveSetting;
